import axios from 'axios'
import Swal from 'sweetalert2'
import { env } from './config/env'

const API_KEY_TOKEN = env.REACT_APP_KEY_TOKEN

export const loginRequest = payload => ({
  type: 'LOGIN_REQUEST',
  payload,
})

export const logOut = () => ({
  type: 'LOG_OUT',
})

export const setTitle = payload => ({
  type: 'SET_TITLE',
  payload,
})

export const setThemeApp = payload => ({
  type: 'SET_THEME',
  payload,
})

export const setSocket = payload => ({
  type: 'SET_SOCKET',
  payload,
})

export const addItemList = payload => ({
  type: 'CREATE_ITEMS_LIST',
  payload,
})

export const deleteItemList = payload => ({
  type: 'DELETE_ITEMS_LIST',
  payload,
})

export const createNewPallet = payload => ({
  type: 'CREATE_NEW_PALLET',
  payload,
})

export const cleanNewPallet = payload => ({
  type: 'CLEAN_NEW_PALLET',
  payload,
})

export const setUnits = payload => ({
  type: 'SET_UNITS',
  payload,
})

export const cleanStock = payload => ({
  type: 'CLEAN_STOCK',
  payload,
})

export const setModal = payload => ({
  type: 'SET_MODAL',
  payload,
})
export const setModalReview = payload => ({
  type: 'SET_MODAL_REVIEW',
  payload,
})

export const setLoading = payload => ({
  type: 'SET_LOADING',
  payload,
})

export const setUser =
  (payload, redirectionUrl) => async dispatch => {
    const { user, password } = payload
    try {
      const res = await axios({
        method: 'post',
        url: `${env.REACT_APP_API}auth/sing-in`,
        auth: {
          username: user,
          password,
        },
        data: {
          apiKeyToken: API_KEY_TOKEN,
          source: 'cms',
        },
      })

      sessionStorage.setItem('token', res.data.token)
      sessionStorage.setItem('user', res.data.user.user)
      sessionStorage.setItem('name', res.data.user.name)
      sessionStorage.setItem('id', res.data.user.id)
      sessionStorage.setItem('role_id', res.data.user.role_id)

      window.location.href = redirectionUrl

      dispatch({
        type: 'LOGIN_REQUEST',
      })
    } catch (error) {
      const message = error?.response?.data?.message || 'Usuario o contraseña incorrectos'
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: message,
      })
    }
  }

//CRUD

export const getAll = (endPoint, typeAction) => async dispatch => {
  const storedJwt = sessionStorage.getItem('token')
  try {
    const res = await axios({
      url: `${env.REACT_APP_API}${endPoint}`,
      headers: { Authorization: `Bearer ${storedJwt}` },
      method: 'get',
    })
    dispatch({
      type: typeAction,
      payload: res.data,
    })
  } catch (error) {
    console.log(error)
  }
}

export const get = (endPoint, typeAction) => async dispatch => {
  const storedJwt = sessionStorage.getItem('token')
  try {
    const res = await axios({
      url: `${env.REACT_APP_API}${endPoint}`,
      headers: { Authorization: `Bearer ${storedJwt}` },
      method: 'get',
    })
    dispatch({
      type: typeAction,
      payload: res.data.data,
    })
  } catch (error) {
    console.log(error)
  }
}

export const create =
  (endPoint, typeAction, data) => async dispatch => {
    const storedJwt = sessionStorage.getItem('token')
    try {
      const res = await axios({
        url: `${env.REACT_APP_API}${endPoint}`,
        headers: { Authorization: `Bearer ${storedJwt}` },
        method: 'post',
        data: data,
      })
      dispatch({
        type: typeAction,
        payload: res.data,
      })
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
      })
      Toast.fire({
        icon: 'success',
        title: 'Se guardo correctamente',
      })
      return res.data
    } catch (error) {
      console.log(error)
      Swal.fire({
        title: 'Error!',
        text: 'Ah ocurrido un error',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar',
      })
    }
  }

export const update =
  (endpoint, typeAction, data) => async dispatch => {
    const storedJwt = sessionStorage.getItem('token')

    try {
      const res = await axios({
        url: `${env.REACT_APP_API}${endpoint}`,
        headers: { Authorization: `Bearer ${storedJwt}` },
        method: 'put',
        data: data,
      })
      dispatch({
        type: typeAction,
        payload: data,
        patchPayload: res.data,
      })
    } catch (error) {
      console.log(error)
    }
  }

// PDF de la guía: va con el token, así que se baja como blob y se abre local.
export const getOrderLabelUrl = async (orderId, sequence) => {
  const storedJwt = sessionStorage.getItem('token')

  const res = await axios({
    url: `${env.REACT_APP_API}orders/${encodeURIComponent(orderId)}/labels/${sequence}`,
    headers: { Authorization: `Bearer ${storedJwt}` },
    method: 'get',
    responseType: 'blob',
  })

  return window.URL.createObjectURL(res.data)
}

export const cancelOrder = orderId => async dispatch => {
  const storedJwt = sessionStorage.getItem('token')

  const res = await axios({
    url: `${env.REACT_APP_API}orders/${orderId}/cancel`,
    headers: { Authorization: `Bearer ${storedJwt}` },
    method: 'put',
  })

  dispatch({
    type: 'CANCEL_ORDER',
    payload: res.data.data,
  })

  return res.data
}

export const deleted = (endpoint, typeAction) => async dispatch => {
  const storedJwt = sessionStorage.getItem('token')

  try {
    const res = await axios({
      url: `${env.REACT_APP_API}${endpoint}`,
      headers: { Authorization: `Bearer ${storedJwt}` },
      method: 'delete',
    })
    dispatch({
      type: typeAction,
      payload: res.data.data,
    })
  } catch (error) {
    console.log(error)
  }
}

//CREATE ATTACHMENT

export const createFile =
  (endPoint, typeAction, data) => async dispatch => {
    const storedJwt = sessionStorage.getItem('token')

    const formData = new FormData()
    Object.keys(data).map(key => {
      if (key.includes('file')) {
        return formData.append(key, data[key][0])
      } else {
        return formData.append(key, data[key])
      }
    })

    try {
      await axios({
        url: `${env.REACT_APP_API}${endPoint}`,
        headers: {
          Authorization: `Bearer ${storedJwt}`,
          'Content-Type': 'multipart/form-data',
        },
        method: 'post',
        data: formData,
      })

      dispatch({
        type: typeAction,
      })

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
      })
      Toast.fire({
        icon: 'success',
        title: 'Se guardo correctamente',
      })
    } catch (error) {
      console.log(error)
      Swal.fire({
        title: 'Error!',
        text: 'Ah ocurrido un error',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar',
      })
    }
  }

export const updateFile =
  (endPoint, typeAction, data) => async dispatch => {
    const storedJwt = sessionStorage.getItem('token')

    const formData = new FormData()
    Object.keys(data).map(key => {
      if (key.includes('file')) {
        return formData.append(key, data[key][0])
      } else {
        return formData.append(key, data[key])
      }
    })

    try {
      await axios({
        url: `${env.REACT_APP_API}${endPoint}`,
        headers: {
          Authorization: `Bearer ${storedJwt}`,
          'Content-Type': 'multipart/form-data',
        },
        method: 'put',
        data: formData,
      })

      dispatch({
        type: typeAction,
      })

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
      })
      Toast.fire({
        icon: 'success',
        title: 'Se guardo correctamente',
      })
    } catch (error) {
      console.log(error)
      Swal.fire({
        title: 'Error!',
        text: 'Ah ocurrido un error',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar',
      })
    }
  }

// GET QUERY

export const getAllQuery =
  (endPoint, typeAction, data) => async dispatch => {
    const storedJwt = sessionStorage.getItem('token')
    try {
      const res = await axios({
        url: `${env.REACT_APP_API}${endPoint}`,
        headers: { Authorization: `Bearer ${storedJwt}` },
        method: 'get',
        data,
      })
      dispatch({
        type: typeAction,
        payload: res.data,
      })
    } catch (error) {
      console.log(error)
    }
  }

export const createNotification = data => async dispatch => {
  const storedJwt = sessionStorage.getItem('token')
  try {
    const res = await axios({
      url: `${env.REACT_APP_API}notifications`,
      headers: { Authorization: `Bearer ${storedJwt}` },
      method: 'post',
      data: data,
    })
    dispatch({
      type: 'CREATE_NOTIFICATION',
      payload: res.data,
    })
  } catch (error) {
    console.log(error)
  }
}
